import { render, staticRenderFns } from "./DocumentsWithoutKeywordsWarning.vue?vue&type=template&id=be12ad96"
import script from "./DocumentsWithoutKeywordsWarning.vue?vue&type=script&lang=js"
export * from "./DocumentsWithoutKeywordsWarning.vue?vue&type=script&lang=js"
import style0 from "./DocumentsWithoutKeywordsWarning.vue?vue&type=style&index=0&id=be12ad96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports